import React from 'react';
import { Box, Typography } from '@mui/material';

interface StreakDisplayProps {
  currentStreak: number;
  longestStreak: number;
  isBroken: boolean;
}

/**
 * StreakDisplay — shows current streak count with fire animation.
 * Displays motivational message when streak is broken.
 */
const StreakDisplay: React.FC<StreakDisplayProps> = ({ currentStreak, longestStreak, isBroken }) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Typography sx={{ fontSize: '1.2rem' }}>🔥</Typography>
      <Box>
        <Typography variant="body2" sx={{ fontWeight: 700 }}>
          {currentStreak} active {currentStreak === 1 ? 'day' : 'days'} this month
        </Typography>
        {longestStreak > currentStreak && (
          <Typography variant="caption" color="text.secondary">
            Best month: {longestStreak} days
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default StreakDisplay;
